export default __webpack_public_path__ + "static/1203-ac3e0663ef8e6129077c4aa6f5b7b549.gif";